export class OverrideSampleExample {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "raw",
            "baseName": "raw",
            "type": "string",
            "format": ""
        },
        {
            "name": "parsed",
            "baseName": "parsed",
            "type": "string",
            "format": ""
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideSampleExample.attributeTypeMap;
    }
    constructor() {
    }
}
